<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="EPV"><span class="ePub-I">One of two things: either the spiral</span></p>
<p class="EPV"><span class="ePub-I">or to be sent out into the air.</span></p>
<p class="EPC">—Christophe Tarkos</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?23f3bbb8